import React from "react";
import { Box, Backdrop } from "@mui/material";
import ChristmasPromoCard from "./ChristmasPromoCard";

type ChristmasPromoModalProps = {
  open: boolean;
  onClose: () => void;
};

const ChristmasPromoModal: React.FC<ChristmasPromoModalProps> = ({
  open,
  onClose,
}) => {
  if (!open) return null;

  return (
    <>
      <Backdrop
        open={open}
        onClick={onClose}
        sx={{
          zIndex: 1200,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1300,
        }}
      >
        <ChristmasPromoCard onClose={onClose} />
      </Box>
    </>
  );
};

export default ChristmasPromoModal;
